export default "__VITE_ASSET__M91hauXN__"